/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_404_LabelInputs */

const ja_error_404_label = /** @type {(inputs: Error_404_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「404エラー」`)
};

const en_error_404_label = /** @type {(inputs: Error_404_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`404 Error`)
};

/**
* | output |
* | --- |
* | "404 Error" |
*
* @param {Error_404_LabelInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const error_404_label = /** @type {((inputs?: Error_404_LabelInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_404_LabelInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_error_404_label(inputs)
	return en_error_404_label(inputs)
});